export default __webpack_public_path__ + "static/media/gi.4fe8cc6e.svg";